module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-stone-path-background.cb2ffad1.png";